import React, { useState, useEffect } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import SuperadminLayout from './SuperadminLayout';
import axios from '../../axios/axiosconf';
import './SuperadminStyles.css';

const EditarPlantillaSimple = () => {
    const history = useHistory();
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(true);
    const [nombre, setNombre] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [especialidad, setEspecialidad] = useState('');
    const [estructuraJson, setEstructuraJson] = useState('');
    const [jsonError, setJsonError] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('superadmin_token');
        const user = localStorage.getItem('superadmin_user');
        if (!token || !user) {
            history.push('/superadmin/login');
            return;
        }
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        cargarPlantilla();
    }, [history, id]);

    const cargarPlantilla = async () => {
        try {
            const response = await axios.get(`/superadmin/plantillas-admin/${id}`);
            const p = response.data;
            setNombre(p.nombre || '');
            setDescripcion(p.descripcion || '');
            setEspecialidad(p.especialidad || '');

            let estructura = p.estructura_json;
            if (typeof estructura === 'string') {
                try { estructura = JSON.parse(estructura); } catch (e) { /* keep as string */ }
            }
            setEstructuraJson(typeof estructura === 'object' ? JSON.stringify(estructura, null, 2) : (estructura || ''));
            setLoadingData(false);
        } catch (error) {
            console.error('Error cargando plantilla:', error);
            alert('Error al cargar la plantilla');
            history.push('/superadmin/plantillas');
        }
    };

    const validarJson = (texto) => {
        if (!texto.trim()) { setJsonError(''); return false; }
        try {
            const parsed = JSON.parse(texto);
            if (!parsed.secciones || !Array.isArray(parsed.secciones)) {
                setJsonError('El JSON debe contener un array "secciones"');
                return false;
            }
            for (let i = 0; i < parsed.secciones.length; i++) {
                const s = parsed.secciones[i];
                if (!s || typeof s !== 'object') {
                    setJsonError(`secciones[${i}] no es un objeto válido`);
                    return false;
                }
                // Campo suelto (tiene tipo) metido como sección
                if (s.tipo && !Array.isArray(s.campos)) {
                    setJsonError(
                        `secciones[${i}] ("${s.id || s.label || 'sin id'}") es un campo, no una sección. ` +
                        'Cada sección debe tener "titulo" y "campos": [...]. Envuelva el campo dentro de campos.'
                    );
                    return false;
                }
                if (!Array.isArray(s.campos)) {
                    setJsonError(`secciones[${i}] ("${s.titulo || s.id || 'sin título'}") debe tener un array "campos"`);
                    return false;
                }
                for (let j = 0; j < s.campos.length; j++) {
                    const c = s.campos[j];
                    if (c && Array.isArray(c.campos)) {
                        setJsonError(
                            `secciones[${i}].campos[${j}] ("${c.id || c.titulo}") es una subsección anidada. ` +
                            'SmileWEB no soporta secciones dentro de campos: súbala a "secciones" o apláne los campos.'
                        );
                        return false;
                    }
                    if (c && !c.tipo) {
                        setJsonError(`secciones[${i}].campos[${j}] ("${c.id || c.label || j}") no tiene "tipo"`);
                        return false;
                    }
                }
            }
            setJsonError('');
            return true;
        } catch (e) {
            setJsonError('JSON inválido: ' + e.message);
            return false;
        }
    };

    const handleJsonChange = (e) => {
        const valor = e.target.value;
        setEstructuraJson(valor);
        if (valor.trim()) validarJson(valor);
        else setJsonError('');
    };

    const formatearJson = () => {
        try {
            const parsed = JSON.parse(estructuraJson);
            setEstructuraJson(JSON.stringify(parsed, null, 2));
            setJsonError('');
        } catch (e) {
            setJsonError('No se puede formatear: JSON inválido');
        }
    };

    const guardarPlantilla = (e) => {
        e.preventDefault();
        if (!nombre.trim()) { alert('Ingrese el nombre'); return; }
        if (!estructuraJson.trim()) { alert('Ingrese la estructura JSON'); return; }
        if (!validarJson(estructuraJson)) { alert('El JSON no es válido'); return; }

        setLoading(true);
        const data = {
            nombre,
            descripcion,
            especialidad,
            estructura: JSON.parse(estructuraJson)
        };

        axios.put(`/superadmin/plantillas-admin/${id}`, data)
            .then(() => {
                setLoading(false);
                alert('Plantilla actualizada exitosamente');
                history.push('/superadmin/plantillas');
            })
            .catch(error => {
                setLoading(false);
                alert('Error: ' + (error.response?.data?.message || 'Error desconocido'));
            });
    };

    if (loadingData) {
        return (
            <SuperadminLayout>
                <div className="text-center p-5">
                    <div className="spinner-border text-info" role="status">
                        <span className="sr-only">Cargando...</span>
                    </div>
                </div>
            </SuperadminLayout>
        );
    }

    return (
        <SuperadminLayout>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4><i className="fas fa-file-code"></i> Editar Plantilla Simple (ID: {id})</h4>
                <Link to="/superadmin/plantillas" className="btn btn-secondary">
                    <i className="fas fa-arrow-left"></i> Volver
                </Link>
            </div>

            <form onSubmit={guardarPlantilla}>
                <div className="card mb-3">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Nombre <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" value={nombre}
                                        onChange={(e) => setNombre(e.target.value)} required />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Especialidad</label>
                                    <input type="text" className="form-control" value={especialidad}
                                        onChange={(e) => setEspecialidad(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Descripción</label>
                                    <input type="text" className="form-control" value={descripcion}
                                        onChange={(e) => setDescripcion(e.target.value)} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card mb-3">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <span><i className="fas fa-code"></i> Estructura JSON</span>
                        <button type="button" className="btn btn-sm btn-outline-info" onClick={formatearJson}>
                            <i className="fas fa-indent"></i> Formatear JSON
                        </button>
                    </div>
                    <div className="card-body">
                        <textarea
                            className={`form-control ${jsonError ? 'is-invalid' : estructuraJson.trim() ? 'is-valid' : ''}`}
                            rows="18"
                            value={estructuraJson}
                            onChange={handleJsonChange}
                            style={{ fontFamily: 'monospace', fontSize: '13px' }}
                        />
                        {jsonError && <div className="invalid-feedback">{jsonError}</div>}
                    </div>
                </div>

                <button type="submit" className="btn btn-superadmin mr-2" disabled={loading}>
                    {loading ? <><span className="spinner-border spinner-border-sm mr-2"></span>Guardando...</> :
                        <><i className="fas fa-save"></i> Guardar Cambios</>}
                </button>
                <Link to="/superadmin/plantillas" className="btn btn-secondary">Cancelar</Link>
            </form>
        </SuperadminLayout>
    );
};

export default EditarPlantillaSimple;
